import React from 'react';
import styled from 'styled-components';
const Icon = styled.svg`
  width: 25px;
  height: 25px;
`;
export default (() => /*#__PURE__*/React.createElement(Icon, {
  width: "25",
  height: "25",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-label": "geluid uit"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M0 0h11v16H0z"
})), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#FFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.5 4L2 12.5l8.5 8.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1 9h7v7H1z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(13 4)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "b",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "#FFF",
  strokeWidth: "2",
  mask: "url(#b)",
  cx: "-.5",
  cy: "8.5",
  r: "1.5"
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "#FFF",
  strokeWidth: "2",
  mask: "url(#b)",
  cx: "-.5",
  cy: "8.5",
  r: "5.5"
})))));